
import React from 'react'
import { Col, Row } from 'reactstrap';
import { useFormikContext } from 'formik';
import ValidationField from '../../Components/ValidationField/ValidationField';

function FormSocialMedia() {
  const formik = useFormikContext<any>();



  return (
    <Row xs={1} sm={1} md={1} lg={2} xl={2}>
      <Col>
        <ValidationField name="link" type="text" label='link' placeholder='placeholder' />

      </Col>
      <Col>
        <ValidationField name="image" type="File" label='image' placeholder='placeholder' />
        <ValidationField name="is_active" type="Checkbox" label='is_active' placeholder='placeholder' Group />

      </Col>


    </Row>
  )
}

export default FormSocialMedia


